import {
    CHeader,
    CHeaderBrand,
    CHeaderNav,
    CHeaderNavItem,
    CToggler,
} from "@components/template";
import React, { useEffect, useState } from "react";
import { Dropdown, Form, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
    startUIToggleSidebar,
    startUIToggleSidebarMobile,
} from "../../redux/actions/administrador/ui/ui";
import { TheHeaderDropdown } from "./index";
import { IconApp } from "../IconApp";
import useDebounce from "../../hooks/useDebounce";
import {
    searchBar,
    startShowStudentsSearchBar,
} from "../../redux/actions/students/students";
import { StudentStatusIcon } from "../StudentStatusIcon";
import { useHasPermission } from "../../hooks/useHasPermission";
import { AvatarApp } from "@components/AvatarApp";

// SearchBar Component
const SearchBar = () => {
    const dispatch = useDispatch();
    const { searchBar: searchBarList } = useSelector((state) => state.students);

    const [showDropdown, setShowDropdown] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const debouncedSearchValue = useDebounce(searchValue, 500);

    // Efecto unificado para manejar la búsqueda
    useEffect(() => {
        if (debouncedSearchValue !== "") {
            dispatch(
                startShowStudentsSearchBar({ query: debouncedSearchValue })
            );
        } else {
            dispatch(searchBar([]));
        }
    }, [debouncedSearchValue, dispatch]);

    // Manejar cambios en el input
    const handleSearchValue = (e) => {
        setSearchValue(e.target.value);
    };

    // Mostrar dropdown al enfocar
    const handleFocus = () => {
        setShowDropdown(true);
    };

    // Ocultar dropdown con retraso al perder foco
    const handleBlur = () => {
        setTimeout(() => setShowDropdown(false), 100);
    };

    // Prevenir cierre del dropdown en mousedown
    const preventBlur = (e) => {
        e.preventDefault();
    };

    return (
        <div style={{ position: "relative", width: "400px" }}>
            <div className="input-group header-search-group">
                <span className="input-group-text border-0">
                    <IconApp
                        iconClassName={"fa fa-search pe-1"}
                        fontSize="1.1rem"
                        color={"grey"}
                    />
                </span>
                <Form.Control
                    style={{ fontSize: "1.1rem" }}
                    type="text"
                    placeholder="Buscar alumno"
                    value={searchValue}
                    onChange={handleSearchValue}
                    className="border-0"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
            {showDropdown && searchBarList.length > 0 && (
                <div className="student-search-container">
                    <Dropdown.Menu
                        show
                        style={{
                            position: "absolute",
                            width: "100%",
                        }}
                        onMouseDown={preventBlur}
                    >
                        {searchBarList.map((data, index) => (
                            <Dropdown.Item
                                key={index}
                                as="a"
                                href={`/app/students/form/${data.student_number}`}
                                target="_self"
                                title={`${data.username} - ${data.status}${
                                    data?.curriculum?.name &&
                                    ` - ${data.curriculum.name}`
                                }`}
                                className="text-truncate user-select-none dropdown-item-custom"
                                style={{ maxWidth: "100%" }}
                                onMouseDown={preventBlur}
                            >
                                <div className="student-search-item">
                                    <div className="student-avatar mr-2">
                                        <AvatarApp
                                            img={data.student.uri}
                                            textToGenerateAvatar={
                                                data.student.full_name
                                            }
                                            size={35}
                                        />
                                    </div>
                                    <div className="student-info">
                                        <div className="student-name">
                                            {data.student.full_name}
                                            <StudentStatusIcon
                                                status={data.status}
                                                iconClassName="fa-circle"
                                                iconSizeClassName="fa-sm"
                                            />
                                        </div>
                                        <div className="student-details">
                                            <span className="student-number">
                                                {data.student_number}
                                            </span>
                                            {data?.curriculum?.name && (
                                                <span className="student-curriculum">
                                                    {data.curriculum.name}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </div>
            )}
        </div>
    );
};
// TheHeader Component
const TheHeader = () => {
    const dispatch = useDispatch();

    const { sidebarShow } = useSelector((state) => state.ui);
    const { color_nav, logo, tiny_name } = useSelector((state) => state.config);
    const { session } = useSelector((state) => state.auth);
    const { hasPermission } = useHasPermission();

    const toggleSidebar = () => dispatch(startUIToggleSidebar(sidebarShow));
    const toggleSidebarMobile = () =>
        dispatch(startUIToggleSidebarMobile(sidebarShow));

    const canShowSearchBar =
        session === "operator" && hasPermission(["READ_STUDENTS_DETAIL"]);

    return (
        <CHeader
            withSubheader
            colorScheme="#221e1e"
            style={{
                backgroundColor: color_nav,
                border: "0px solid" + color_nav,
            }}
        >
            <CToggler
                inHeader
                className="ml-md-3 d-lg-none"
                onClick={toggleSidebarMobile}
                name="toggle-md"
            >
                <IconApp
                    iconClassName="fa-solid fa-bars text-white"
                    fontSize="2.5rem"
                />
            </CToggler>
            <CToggler
                inHeader
                className="ml-3 d-md-down-none header-toggler-color"
                onClick={toggleSidebar}
                name="toggle-lg"
            >
                <IconApp
                    iconClassName="fa-solid fa-bars text-white"
                    fontSize="2.5rem"
                />
            </CToggler>
            <CHeaderBrand className="mx-auto d-lg-none" to="/">
                <Image
                    className="animate__animated animate__backInLeft"
                    src={`/storage/${logo}`}
                    rounded
                    style={{
                        height: 40,
                        objectFit: "scale-down",
                        marginRight: 0,
                    }}
                    alt={tiny_name}
                />
            </CHeaderBrand>

            <CHeaderNav className="d-md-down-none mr-auto">
                {canShowSearchBar && <SearchBar />}

                {!sidebarShow && (
                    <CHeaderNavItem className="px-3">
                        <Image
                            className="animate__animated animate__backInLeft"
                            src={`/storage/${logo}`}
                            rounded
                            style={{
                                height: 40,
                                objectFit: "scale-down",
                                marginRight: 0,
                            }}
                            alt={tiny_name}
                        />
                    </CHeaderNavItem>
                )}
            </CHeaderNav>

            <CHeaderNav className="px-3 text-right">
                <TheHeaderDropdown />
            </CHeaderNav>
        </CHeader>
    );
};

export default TheHeader;
